import {
  FETCH_FARE_RULES,
  FETCH_FARE_RULES_SUCCESS,
  FETCH_FARE_RULES_FAILED,
  EDIT_FARE_RULES
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, push, set, remove } from "firebase/database";

export const fetchFareRules = () => (dispatch) => {
  const { fareRulesRef } = firebase;

  dispatch({
    type: FETCH_FARE_RULES,
    payload: null
  });

  onValue(fareRulesRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: FETCH_FARE_RULES_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_FARE_RULES_SUCCESS,
        payload: []
      });
    }
  }, error => {
    dispatch({
      type: FETCH_FARE_RULES_FAILED,
      payload: error.message
    });
  });
};

export const editFareRule = (fareRule, method) => async (dispatch) => {
  const {
    fareRulesRef,
    fareRuleEditRef
  } = firebase;

  dispatch({
    type: EDIT_FARE_RULES,
    payload: { method, fareRule }
  });

  if (method === 'Add') {
    await push(fareRulesRef, {
      ...fareRule,
      createdAt: fareRule.createdAt || new Date().getTime(),
      updatedAt: new Date().getTime()
    });
  } else if (method === 'Delete') {
    await remove(fareRuleEditRef(fareRule.id));
  } else {
    const data = { ...fareRule, updatedAt: new Date().getTime() };
    delete data.tableData;
    await set(fareRuleEditRef(fareRule.id), data);
  }
};
